export const API_CONFIG = {
  BASE_URL: 'https://api.vps-kurznews.eu',//'http://0.0.0.0:8080',//
  ENDPOINTS: {
    LOGIN: '/login',
    NEWS: {
      BASE: '/admin/news',
      MANUAL: '/admin/news/manual',
      IMPORT_BY_LINK: '/admin/news/import/by-link',
      EDIT: (id: string) => `/admin/news/${id}/edit`,
      TOGGLE: (id: string, type: string) => `/admin/news/${id}/${type}`,
      BULK_APPROVE: '/admin/news/bulk/approve',
      BULK_REJECT: '/admin/news/bulk/reject',
    },
    RSS: {
      BASE: '/admin/rss',
      DELETE: '/admin/rss/delete',
      EDIT: '/admin/rss/edit',
      SYNC_LATEST_NEWS: '/admin/rss/sync-latest-news',
    },
    TOPICS: {
      BASE: '/admin/topics',
      UPDATE: '/admin/topics/update',
    },
    HOT_TOPICS: {
      BASE: '/admin/hot-topics',
      CREATE: '/admin/hot-topics',
      UPDATE: (id: number) => `/admin/hot-topics/${id}`,
      DELETE: (id: number) => `/admin/hot-topics/${id}`,
    },
    FCM: {
      SEND_TO_TOPIC: '/api/firebase/sendNotificationToTopic',
      SEND_TO_TOKEN: '/api/firebase/sendNotificationToToken',
      UPLOAD_IMAGE: '/upload/image',
    },
    IMAGE: {
      GENERATE_OVERLAY: '/image/generate-overlay',
      GENERATE_OVERLAY_FROM_URL: '/image/generate-overlay-from-url',
      GENERATE_QUOTE: '/image/generate-quote',
    },
  },
}; 
